import { Component, OnInit, ViewChild } from '@angular/core';
import { Apiservice } from '../../../services/api.service';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';

@Component({
  selector: 'app-crm-send-messagge',
  templateUrl: './crm-send-messagge.component.html',
  styleUrls: ['./crm-send-messagge.component.css']
})
export class CrmSendMessaggeComponent implements OnInit {
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;
  @ViewChild('contattiForm', { static: false }) contattiForm: NewNicaFormComponent;
  dataCod: number;
  dataCodAss: string;
  myFilter;

  constructor(private api: Apiservice) { }

  ngOnInit() {
    this.myFilter = `?CodContatto=${this.dataCod}`;
  }

  onAllEvents(event) {
    if (event.name === 'onRowPrepared') {
      console.log('onRowPrepared', event);
      if (event.data && event.data.letto === 1) {
        event.rowElement.querySelector('.dx-command-edit').style.visibility = 'hidden';
      }
    }
  }

  sendNewMessagge(event) {
    console.log('il mio evento', event);
    if (event.name === 'invia') {
      if (event.data.messaggio !== '' && event.data.messaggio !== null) {
        let now = new Date();
        const dataSendMessage = {
          CodContatto: this.dataCod,
          CodAss: this.dataCodAss,
          messaggio: event.data.messaggio,
          dataNotifica: now,
        }

        this.api.PostApiRest(`messaggi`, dataSendMessage).then(el => {
          //svuoto il messaggio una volta salvato
          //event.data.messaggio = '';
          this.contattiForm.formRefreshInputData('messaggio', '');
          this.nicaAnagrafica.refresh();
          notify({
            message: 'Messaggio inviato con successo',
            height: 45,
            width: 250,
            position: 'center center'

          }, 'success', 2000);
        }).catch(err => {
          console.error('Errore di chiamata')
        })
      } else {
        alert('Non hai inviato nessun messaggio', 'Messaggio non inviato');
      }
    }
  }



}


